import { Quill } from 'react-quill';

const Inline = Quill.import('blots/inline');

export class RBBlot extends Inline {}
